import { Component } from "react";
import * as Scrivito from "scrivito";
import classNames from "classnames";
import { formInputId } from "../../formHelpers";

class RadioButtonWidgetComponent extends Component {
  handleInputChange = (_event) => {
    const { widget } = this.props;
    const myValue = widget.get("value") || widget.get("text");

    this.props.handleInputChange(myValue);
  };

  render() {
    const { widget, radioValue, inputName } = this.props;
    const inputId = formInputId(widget);
    const myValue = widget.get("text");
    const checked = radioValue === myValue;

    return (
      <Scrivito.WidgetTag tag="div" className="radio-group-element">
        <input
          type="radio"
          name={inputName}
          id={inputId}
          checked={checked}
          onChange={this.handleInputChange}
          aria-checked={checked}
        />
        <label
          htmlFor={inputId}
          className={classNames("radio-label", { checked })}
        >
          <Scrivito.ContentTag tag="span" content={widget} attribute="text" />
        </label>
      </Scrivito.WidgetTag>
    );
  }
}

Scrivito.provideComponent("RadioButtonWidget", RadioButtonWidgetComponent);
